import { useEffect, useRef, useState, type ReactNode } from "react";
export function Notice({
  children,
  kind = "error",
}: {
  children: ReactNode;
  kind?: string;
}) {
  return children ? (
    <p
      className={"notice " + kind}
      role={kind === "error" ? "alert" : "status"}
    >
      {children}
    </p>
  ) : null;
}
export function Empty({
  title,
  text,
  action,
}: {
  title: string;
  text?: string;
  action?: ReactNode;
}) {
  return (
    <section className="empty">
      <span className="empty-icon" aria-hidden="true">
        ◇
      </span>
      <h2>{title}</h2>
      {text && <p>{text}</p>}
      {action}
    </section>
  );
}
export function Loading() {
  return (
    <p className="loading" role="status">
      <span />
      正在加载…
    </p>
  );
}
export function PageTitle({
  title,
  subtitle,
  action,
}: {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}) {
  return (
    <div className="page-title">
      <div>
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
export function Modal({
  title,
  children,
  onClose,
}: {
  title: string;
  children: ReactNode;
  onClose: () => void;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    ref.current?.showModal();
    return () => ref.current?.close();
  }, []);
  return (
    <dialog
      ref={ref}
      className="dialog"
      aria-label={title}
      onCancel={(e) => {
        e.preventDefault();
        onClose();
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <header>
        <h2>{title}</h2>
        <button className="icon-button" onClick={onClose} aria-label="关闭">
          ×
        </button>
      </header>
      {children}
    </dialog>
  );
}
export function CopyButton({
  value,
  label = "复制",
}: {
  value: string;
  label?: string;
}) {
  const [done, setDone] = useState(false),
    [error, setError] = useState("");
  return (
    <>
      <button
        className="button subtle small"
        onClick={async () => {
          try {
            await navigator.clipboard.writeText(value);
            setDone(true);
            setTimeout(() => setDone(false), 2000);
          } catch {
            setError("请手动选择并复制内容");
          }
        }}
      >
        {done ? "已复制" : label}
      </button>
      {error && <span role="status">{error}</span>}
    </>
  );
}
